module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/PrinceOfPersia_xbox_lrg.1fb43ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/PrinceOfPersia_xbox_lrg.jpg
// module id = vlOD
// module chunks = 0